import * as React from "react";

import primaryColour from "../constants";

interface WarningProps extends React.SVGProps<SVGSVGElement> {
  exclamationMarkFill?: string;
}

function SvgWarning(props: WarningProps): React.ReactElement {
  const { fill = primaryColour, exclamationMarkFill = "#FFFFFF" } = props;
  return (
    <svg width="12" height="11" viewBox="0 0 12 11" fill="none" {...props}>
      <path
        d="M4.40663 0.872868L0.324843 7.14001C-0.52357 8.44265 0.388718 10.1875 1.91822 10.1875H10.0818C11.6113 10.1875 12.5236 8.44265 11.6752 7.14001L7.59337 0.872869C6.83538 -0.290956 5.16462 -0.290956 4.40663 0.872868Z"
        fill={fill}
      />
      <path
        d="M5.25 3.13522C5.25 2.70242 5.58579 2.35156 6 2.35156C6.41421 2.35156 6.75 2.70242 6.75 3.13522V5.48618C6.75 5.91898 6.41421 6.26983 6 6.26983C5.58579 6.26983 5.25 5.91898 5.25 5.48618V3.13522Z"
        fill={exclamationMarkFill}
      />
      <path
        d="M5.25 7.83714C5.25 7.40434 5.58579 7.05349 6 7.05349C6.41421 7.05349 6.75 7.40434 6.75 7.83714C6.75 8.26994 6.41421 8.62079 6 8.62079C5.58579 8.62079 5.25 8.26994 5.25 7.83714Z"
        fill={exclamationMarkFill}
      />
    </svg>
  );
}

export default SvgWarning;
